import { Routes, RouterModule } from '@angular/router';
import { SubscribeComponent } from './shared/subscribe/subscribe.component';
import { SuccessComponent } from './shared/success/success.component';
import { VerificationComponent } from './shared/verification/verification.component';
import { RoamingSearchComponent } from './roaming-search/roaming-search.component';
import { ParentalControlAddonsComponent } from './parental-control-addons/parental-control-addons.component';
import { ParentalControlDetailsComponent } from './parental-control-details/parental-control-details.component';
import { ArenaProSuccessComponent } from './shared/arena-pro-success/arena-pro-success.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { ArenaProGamingErrorComponent } from './shared/arena-pro-gaming-error/arena-pro-gaming-error.component';
import { ParentalControlLandingComponent } from './parental-control-landing/parental-control-landing.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./addons/addons.module').then(m => m.AddonsModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./addons/addons.module').then(m => m.AddonsModule)
  },
  
  {
    path: 'home/:id',
    loadChildren: () => import('./addons/addons.module').then(m => m.AddonsModule)
  },
  {
    path: 'home/:id/:params',
    loadChildren: () => import('./addons/addons.module').then(m => m.AddonsModule)
  },
  {
    path: 'addons',
    loadChildren: () => import('./addons/addons.module').then(m => m.AddonsModule)
  },
  {
    path: 'addons/:id',
    loadChildren: () => import('./addons/addons.module').then(m => m.AddonsModule)
  },
  {
    path: 'addons/:id/:params',
    loadChildren: () => import('./addons/addons.module').then(m => m.AddonsModule)
  },
  {
    path: 'addon/detail',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  {
    path: 'addon/detail/:id',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  {
    path: 'addon/detail/:id/:params',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  {
    path: 'addon/subscribe',
    component: SubscribeComponent
  },
  {
    path: 'verification',
    component: VerificationComponent
  },
  {
    path: 'success',
    component: SuccessComponent
  },

  {
    path: 'add-to-bill',
    loadChildren: () => import('./add-to-bill/add-to-bill.module').then(m => m.AddToBillModule)
  },
  
  {
    path: 'add-to-bill/:id',
    loadChildren: () => import('./add-to-bill/add-to-bill.module').then(m => m.AddToBillModule)
  },
  {
    path: 'add-to-bill/:id/:params',
    loadChildren: () => import('./add-to-bill/add-to-bill.module').then(m => m.AddToBillModule)
  },
  {
    path: 'doNotCallRegistry',
    loadChildren: () => import('./do-not-call-registry/do-not-call-registry.module').then(m => m.DoNotCallRegistryModule)
  },
  {
    path: 'roaming',
    component: RoamingSearchComponent
  },
  {
    path: 'thankyou',
    component: ThankyouComponent
  },
  {
    path: 'cnap',
    loadChildren: () => import('./cnap/cnap.module').then(m => m.CnapModule)
  },
  {
    path: 'parentalControl',
    loadChildren: () => import('./parental-control-landing/parental-control-landing.module').then(m => m.ParentalControlLandingModule)
  },
  {
    path: 'parentalControlAddons',
    component: ParentalControlAddonsComponent
  },
  {
    path: 'addon/arenaprosuccess',
    component: ArenaProSuccessComponent
  },
  {
    path: 'parentalControlAddons/detail',
    component: ParentalControlDetailsComponent
  },{
    path: 'tradein',
    loadChildren: () => import('./tradein/tradein.module').then(m => m.TradeinModule)
  },
  {
    path: 'download-pdf',
    loadChildren: () => import('./download-pdf/download-pdf.module').then(m => m.DownloadPdfModule)
  },
  {
    path: 'download-pdf/:id',
    loadChildren: () => import('./download-pdf/download-pdf.module').then(m => m.DownloadPdfModule)
  },
  {
    path: 'download-pdf/:id/:params',
    loadChildren: () => import('./download-pdf/download-pdf.module').then(m => m.DownloadPdfModule)
  },
  
  {
    path: 'addon-subscription',
    loadChildren: () => import('./addon-subscription/addon-subscription.module').then(m => m.AddonSubscriptionModule)
  },
  {
    path: 'addon-subscription/:id',
    loadChildren: () => import('./addon-subscription/addon-subscription.module').then(m => m.AddonSubscriptionModule)
  },
  {
    path: 'addon-subscription/:id/:params',
    loadChildren: () => import('./addon-subscription/addon-subscription.module').then(m => m.AddonSubscriptionModule)
  },
  
  {
    path: 'addon-subscription-detail/',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  
  {
    path: 'addon-subscription-detail/:id',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  
  {
    path: 'addon-subscription-detail/:id/:params',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  {
    path: 'detail',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  
  {
    path: 'detail/:id',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  
  {
    path: 'detail/:id/:params',
    loadChildren: () => import('./addon-details/addon-details.module').then(m => m.AddonDetailsModule)
  },
  {
    path: 'arena-pro-addon-failure',
    component: ArenaProGamingErrorComponent
  },
  
  {
    path: 'arena-pro-addon-failure/:id',
    component: ArenaProGamingErrorComponent
  },
  
  {
    path: 'arena-pro-addon-failure/:id/:params',
    component: ArenaProGamingErrorComponent
  },
  {
    path: 'arena-pro-addon-success',
    component: ArenaProSuccessComponent
  },
  
  {
    path: 'arena-pro-addon-success/:id',
    component: ArenaProSuccessComponent
  },
  
  {
    path: 'arena-pro-addon-success/:id/:params',
    component: ArenaProSuccessComponent
  },
  {
    path: 'choose-packs',
    loadChildren: () =>
    import('./choose-packs/choose-packs.module').then((m) => m.ChoosePacksModule),
  },
  {
    path: 'fault-resolution-report',
    loadChildren: () => import('./fault-resolution-report/fault-resolution-report.module').then(m => m.FaultResolutionModule)
  },
  {path: '**', redirectTo: '/addons'}


];

export const AppRoutes = RouterModule.forRoot(routes,{useHash:false});
